// src/pages/OAuthRedirect.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchTenantHomePath } from '../utils/resolveTenantHome';

function OAuthRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const userData = params.get('user');

      if (userData) {
        try {
          const user = JSON.parse(decodeURIComponent(userData));
          localStorage.setItem('user', JSON.stringify(user));
          if (user?.tenant) {
            localStorage.setItem('tenant_id', String(user.tenant._id || user.tenant));
          }
          if (user?.token) {
            localStorage.setItem('tkn', user.token);
          }
          const homePath = await fetchTenantHomePath({ token: user?.token || localStorage.getItem('tkn') });
          navigate(homePath);
        } catch (e) {
          console.error('Invalid user data', e);
          navigate('/signin');
        }
      } else {
        navigate('/signin');
      }
    };
    run();
  }, [navigate]);

  return <div>Logging you in via Google OAuth...</div>;
}

export default OAuthRedirect;
